// Chronomètres de séance (démarrage, pause, remise à zéro, temps réel enregistré dans le journal d'apprentissage).
window.timeEntryFor = function(taskId) { var log = (window.state.learning && window.state.learning.log) || []; for (var i = log.length - 1; i >= 0; i--) { if (log[i].m === 'time' && log[i].q === taskId) return log[i]; } return null; };
window.timerElapsedMin = function(tm) { if (!tm) return 0; return ((tm.acc || 0) + (tm.start ? Date.now() - tm.start : 0)) / 60000; };
window.anyTimerRunning = function() { var T = window.state.taskTimers; return Object.keys(T).some(function(k) { return T[k] && T[k].start; }); };
window.saveTimers = function() { window.savePrefs(); };
window.actions = window.actions || {};
window.actions.timerStart = function(taskId) { var T = window.state.taskTimers, tm = T[taskId] || (T[taskId] = { acc: 0, start: null }); if (!tm.start) { tm.start = Date.now(); delete tm.abandon; } window.saveTimers(); window.renderContent(); window.ensureTimerTick(); };
window.actions.timerPause = function(taskId) { var tm = window.state.taskTimers[taskId]; if (!tm || !tm.start) return; tm.acc = (tm.acc || 0) + (Date.now() - tm.start); tm.start = null; window.saveTimers(); window.renderContent(); };
// Remise à zéro : on exécute, on annonce, on laisse défaire — le temps accumulé est gardé six secondes dans le
// toast. C'était un confirm() natif, qui figeait la page pour demander la permission d'un geste réversible.
window.actions.timerReset = function(taskId) {
    var avant = window.state.taskTimers[taskId];
    if (!avant) return;
    var copie = { acc: avant.acc || 0, start: avant.start || null, abandon: avant.abandon };
    delete window.state.taskTimers[taskId];
    window.saveTimers(); window.renderContent();
    if (window.toast) window.toast('Chronomètre remis à zéro', { icone: 'arrow-counter-clockwise', action: { label: 'Annuler', fn: function() {
        window.state.taskTimers[taskId] = copie;
        window.saveTimers(); window.renderContent(); window.ensureTimerTick();
    } } });
};
// Au-delà, un chronomètre n'est plus une mesure : il a été oublié. Trois heures dépassent largement la plus
// longue séance estimée par le modèle, et restent sous le seuil de 300 min au-delà duquel recordTaskTime jetait
// déjà la mesure — sans le dire, et sans arrêter le compteur pour autant.
window.TIMER_PLAFOND_MIN = 180;

// Démarrage direct depuis une ligne de séance (bouton « Fiche »). Les autres portes d'entrée — podcast lancé,
// QCM ouvert — passent par autoStartTaskTimer ci-dessous, qui doit d'abord retrouver la tâche depuis un numéro
// d'item ; ici on tient déjà son identifiant.
window.demarrerChronoSeance = function(id) {
    if (window.anyTimerRunning()) return;
    var t = (window.state.tasks || []).find(function(x) { return x.id === id; });
    if (!t || t.status !== 'pending') return;
    window.actions.timerStart(id);
};
// La fiche s'ouvre dans un autre onglet : on écoute le clic sans jamais toucher à la navigation.
if (typeof document !== 'undefined') document.addEventListener('click', function(ev) {
    var el = ev.target && ev.target.closest ? ev.target.closest('[data-chrono-auto]') : null;
    if (el) window.demarrerChronoSeance(el.getAttribute('data-chrono-auto'));
});
// démarrage automatique : podcast lancé ou session de QCM ouverte sur l'item (ou la sous-partie) d'une tâche du jour
window.autoStartTaskTimer = function(n, part, pedia) {
    if (window.anyTimerRunning()) return;
    var td = window.todayStr(), key = window.podcastNorm(part);
    var cands = window.state.tasks.filter(function(t) { if (t.status !== 'pending' || !t.date || t.date > td) return false; var sc = window.taskPodcastScope(t); return sc.n === String(n) && !!sc.pedia === !!pedia && (pedia || window.podcastNorm(sc.part) === key); });
    if (!cands.length && !part) cands = window.state.tasks.filter(function(t) { return t.status === 'pending' && t.date && t.date <= td && String(t.baseItemId || t.itemId) === String(n) && !window.isPediaTask(t) === !pedia; });
    if (!cands.length) return;
    cands.sort(function(a, b) { return a.date.localeCompare(b.date); });
    window.actions.timerStart(cands[0].id);
};
// au cochage « fait » : durée réelle journalisée avec l'estimation du modèle
window.recordTaskTime = function(task) {
    var tm = window.state.taskTimers[task.id]; if (!tm) return;
    var min = Math.round(window.timerElapsedMin(tm)), abandon = !!tm.abandon;
    delete window.state.taskTimers[task.id]; window.saveTimers();
    // Un chronomètre arrêté au plafond ne mesure pas la séance : le journaliser fausserait toutes les estimations.
    if (abandon || min < (window.TIME_MODEL.minLogMinutes == null ? 2 : window.TIME_MODEL.minLogMinutes) || min > 300 || !window.state.learning) return;
    var e = window.estimateTaskMinutes(task);
    window.state.learning.log.push({ m: 'time', t: Date.now(), i: String(task.baseItemId || task.itemId), q: task.id, type: task.type, cat: window.timeCategory(task), words: window.taskWords(task), pedia: window.isPediaTask(task), min: min, est: e.raw });
    if (window.saveLearning) window.saveLearning();
};
window.ensureTimerTick = function() {
    if (window.timerTickId) return;
    window.timerTickId = setInterval(function() {
        window.arreterChronosOublies();
        if (!window.anyTimerRunning()) { clearInterval(window.timerTickId); window.timerTickId = null; return; }
        document.querySelectorAll('[data-timer]').forEach(function(el) { var tm = window.state.taskTimers[el.getAttribute('data-timer')]; if (tm) el.textContent = window.fmtTime(window.timerElapsedMin(tm) * 60); });
    }, 1000);
};
// Met en pause tout chronomètre qui a dépassé le plafond, et le dit. Appelé à chaque seconde du tic, donc aussi
// au retour sur la page : les chronomètres survivent au rechargement (core/persist.js les garde dans les prefs),
// un oubli de la veille est donc arrêté dès que l'onglet rouvre.
window.arreterChronosOublies = function() {
    var T = window.state.taskTimers, arretes = 0;
    Object.keys(T).forEach(function(id) {
        var tm = T[id];
        if (!tm || !tm.start || window.timerElapsedMin(tm) <= window.TIMER_PLAFOND_MIN) return;
        tm.acc = (tm.acc || 0) + (Date.now() - tm.start); tm.start = null; tm.abandon = true; arretes++;
    });
    if (!arretes) return;
    window.saveTimers();
    if (window.toast) window.toast('Chronomètre arrêté après ' + window.formatDuration(window.TIMER_PLAFOND_MIN) + ' : il tournait encore. Cette séance ne comptera pas dans tes estimations de durée.', { icone: 'clock', duree: 8000 });
    if (window.renderContent) window.renderContent();
};
window.estimateDayMinutes = function(tasks) {
    var tot = 0, lines = [], fac = null;
    (tasks || []).forEach(function(t) {
        if (t.status !== 'pending') return;
        var e = window.estimateTaskMinutes(t); tot += e.total;
        if (e.samples >= 3) fac = fac || {}; if (e.samples >= 3) fac[window.timeCategory(t)] = e;
        lines.push(t.type + ' #' + (t.baseItemId || t.itemId) + (window.isPediaTask(t) ? ' (pédiatrie)' : '') + ' : ' + (e.reel ? (e.reel.source === 'item' ? 'ta dernière révision de cet item' : 'médiane de ' + e.reel.n + ' séance(s) sur des fiches comparables') : e.parts.map(function(p) { return p.label + ' ' + p.min + ' min'; }).join(' + ') + (e.factor !== 1 ? ' → ×' + String(e.factor).replace('.', ',') : '')) + ' = ' + window.formatDuration(e.total));
    });
    var calib = fac ? Object.keys(fac).map(function(c) { return (c === 'j0' ? 'J0' : c === 'rev' ? 'révisions' : 'brassage') + ' ×' + String(fac[c].factor).replace('.', ',') + ' (' + fac[c].samples + ' séances)'; }).join(', ') : '';
    return { total: tot, lines: lines, calib: calib };
};
// Deux rendus sont partis au lot de clôture : renderTaskTimer (la pastille de chronomètre d'une séance) et
// renderDayTimeBadge (l'estimation de durée d'un jour). Le lot B13 les avait prouvés morts sans pouvoir y
// toucher ; la preuve a été refaite nom par nom avant de les retirer — aucun appelant dans src/, aucune chaîne
// HTML servie par api.php qui les nomme, une seule définition chacun (donc pas de surcharge-puis-rappel), et
// aucune entrée dans le registre d'actions ni dans un data-action. Le chronomètre lui-même est bien vivant : il
// se lit dans la ligne de séance et se commande depuis son menu (src/ui/components/taskRow.js), et
// estimateDayMinutes ci-dessus sert toujours de calcul.

window.formatDuration = function(minutes) {
    if (minutes == null) return null;
    if (minutes < 60) return minutes + ' min';
    var h = Math.floor(minutes / 60), m = minutes % 60;
    return h + 'h' + (m ? String(m).padStart(2, '0') : '');
};

// Exports : les mêmes fonctions que celles posées sur window (le code historique les lit encore là).
export const timeEntryFor = window.timeEntryFor;
export const timerElapsedMin = window.timerElapsedMin;
export const anyTimerRunning = window.anyTimerRunning;
export const saveTimers = window.saveTimers;
export const autoStartTaskTimer = window.autoStartTaskTimer;
export const recordTaskTime = window.recordTaskTime;
export const ensureTimerTick = window.ensureTimerTick;
export const estimateDayMinutes = window.estimateDayMinutes;
export const formatDuration = window.formatDuration;
export const demarrerChronoSeance = window.demarrerChronoSeance;
export const arreterChronosOublies = window.arreterChronosOublies;
